var _clipPath, _clipPath2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlexa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 173.33333,
    viewBox: "0 0 173.25333 173.33333",
    width: 173.25333,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1299v1300h-1299z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m649.672 1300c-358.801 0-649.67590625-291.02-649.67590625-650 0-329.602 245.21090625-601.8711 563.05890625-644.23828v130.97628c0 36.934-23.282 70.133-58.274 81.871-183.39 61.629-314.582 237.016-309.754 442.352 5.883 249.992 209.418 446.539 459.336 444.019 249.004-2.52 450.087-205.257 450.087-454.98 0-5.691-.14-11.355-.35-16.992-.05-1.262-.09-2.528-.14-3.797-.24-5.234-.56-10.461-.97-15.656-.13-1.653-.29-3.301-.44-4.942-.32-3.633-.69-7.226-1.1-10.82-.46-4.094-.99-8.145-1.56-12.188-.25-1.843-.5-3.691-.78-5.527-55.68-366.957-533.383-573.20691-536.001-574.328 28.325-3.76953 57.215-5.75 86.563-5.75 358.808 0 649.678 291.012 649.678 650 0 358.98-290.87 650-649.678 650"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 173.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m649.672 1300c-358.801 0-649.67590625-291.02-649.67590625-650 0-329.602 245.21090625-601.8711 563.05890625-644.23828v130.97628c0 36.934-23.282 70.133-58.274 81.871-183.39 61.629-314.582 237.016-309.754 442.352 5.883 249.992 209.418 446.539 459.336 444.019 249.004-2.52 450.087-205.257 450.087-454.98 0-5.691-.14-11.355-.35-16.992-.05-1.262-.09-2.528-.14-3.797-.24-5.234-.56-10.461-.97-15.656-.13-1.653-.29-3.301-.44-4.942-.32-3.633-.69-7.226-1.1-10.82-.46-4.094-.99-8.145-1.56-12.188-.25-1.843-.5-3.691-.78-5.527-55.68-366.957-533.383-573.20691-536.001-574.328 28.325-3.76953 57.215-5.75 86.563-5.75 358.808 0 649.678 291.012 649.678 650 0 358.98-290.87 650-649.678 650",
    fill: "#5fcaf4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-98.6406-98.6406h1496.6306v1497.2806h-1496.6306z",
    fill: "#5fcaf4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexa);
export default __webpack_public_path__ + "static/media/alexa.3dfc0e269975460e1406f31d45444bdc.svg";
export { ForwardRef as ReactComponent };